import { heicTo } from 'heic-to';

const base64ToBlob = (base64Data: string, type: string): Blob => {
  const binary = atob(base64Data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: type || 'image/heic' });
};

const isHeicBuffer = (buffer: ArrayBuffer): boolean => {
  if (!buffer || buffer.byteLength < 12) return false;

  const view = new DataView(buffer);

  let ftyp = '';
  for (let i = 4; i < 8; i++) {
    ftyp += String.fromCharCode(view.getUint8(i));
  }
  if (ftyp !== 'ftyp') return false;

  let majorBrand = '';
  for (let i = 8; i < 12; i++) {
    majorBrand += String.fromCharCode(view.getUint8(i));
  }

  const heicBrands = ['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'hevm', 'hevs', 'mif1', 'msf1'];
  return heicBrands.includes(majorBrand);
};

export const convertHeicBlobToJpegUrl = async (blob: Blob): Promise<string> => {
  const buffer = await blob.arrayBuffer();
  if (isHeicBuffer(buffer)) {
    const jpegBlob = await heicTo({
      blob,
      type: 'image/jpeg',
      quality: 0.8,
    });
    return URL.createObjectURL(jpegBlob);
  }
  return URL.createObjectURL(blob);
};

export const convertHeicBase64ToJpegUrl = async (base64Data: string, type = 'image/heic'): Promise<string> => {
  return convertHeicBlobToJpegUrl(base64ToBlob(base64Data, type));
};
